export const INDICATOR = {
	memberPage: 'member-indicator-page',
	eligibilityCard: 'indicator-eligibility-card',
	form: 'indicator-form',
	usernameInput: 'indicator-username-input',
	submit: 'indicator-submit',
	requestRow: 'indicator-request-row',
	approvedCard: 'indicator-approved-card',
	changeIdBtn: 'indicator-change-id-button',
	cancelChangeBtn: 'indicator-cancel-change-button',
	adminPage: 'admin-indicator-page',
	adminRow: 'admin-indicator-row',
	processBtn: 'indicator-process-button',
	revokeBtn: 'indicator-revoke-button',
};
